/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Age_UnknownInputs */

const en_dashboard_age_unknown = /** @type {(inputs: Dashboard_Age_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const pt_br2_dashboard_age_unknown = /** @type {(inputs: Dashboard_Age_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem data`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Dashboard_Age_UnknownInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_age_unknown = /** @type {((inputs?: Dashboard_Age_UnknownInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Age_UnknownInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_age_unknown(inputs)
	return pt_br2_dashboard_age_unknown(inputs)
});